// extracted by mini-css-extract-plugin
export var pillWrapper = "_m2-0";
export var showOverflow = "_m2-1";